import { render, staticRenderFns } from "./BackPasswordForm.vue?vue&type=template&id=8a2b06a4&scoped=true&"
import script from "./BackPasswordForm.vue?vue&type=script&lang=js&"
export * from "./BackPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./BackPasswordForm.vue?vue&type=style&index=0&id=8a2b06a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2b06a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a2b06a4')) {
      api.createRecord('8a2b06a4', component.options)
    } else {
      api.reload('8a2b06a4', component.options)
    }
    module.hot.accept("./BackPasswordForm.vue?vue&type=template&id=8a2b06a4&scoped=true&", function () {
      api.rerender('8a2b06a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/modules/BackPasswordForm.vue"
export default component.exports